// src/pages/Dashboard.jsx
import React, { useEffect, useMemo } from "react";
import { Typography } from "antd";
import { useNavigate } from "react-router-dom";

import { getUser } from "../auth";
import {
  buildAccessMapFromServices,
  hasAccess,
} from "../utils/roleAccess";

import userIcon from "../assets/UserManagement.png";
import productIcon from "../assets/ProductManagement.png";
import custpriceIcon from "../assets/PriceManagement.png";
import marginIcon from "../assets/MarginCalculator.png";
import customerorderIcon from "../assets/CustomerOrder.png";
import quotesIcon from "../assets/Quote.png";
import arrowIcon from "../assets/arrow.svg";

import "./Dashboard.css";

const { Title, Text } = Typography;

const Dashboard = () => {
  const navigate = useNavigate();

  // ✅ ALWAYS call hooks first
  const user = getUser();

  const accessMap = useMemo(() => {
    return buildAccessMapFromServices(user?.services || []);
  }, [user?.services]);

  useEffect(() => {
    document.body.classList.add("dashboard-bg");
    return () => {
      document.body.classList.remove("dashboard-bg");
    };
  }, []);

  // ✅ SAFE early return AFTER hooks
  if (!user) {
    return null;
  }

  const userName = (user.name || "User")
    .toLowerCase()
    .replace(/\b\w/g, (c) => c.toUpperCase());

  const userEmail = user.email || "user@vocovo.com";

  const dashboardCards = [
    { title: "User Management", path: "/users", icon: userIcon, page: "users" },
    { title: "Product Management", path: "/products", icon: productIcon, page: "products" },
    {
      title: "Customer Price Management",
      path: "/discounts",
      icon: custpriceIcon,
      page: "discounts",
    },
    {
      title: "Margin Calculator",
      path: "/margin-calculator",
      icon: marginIcon,
      page: "marginCalculator",
    },
    {
      title: "Customer Orders",
      path: "/orders",
      icon: customerorderIcon,
      page: "orders",
    },
    {
      title: "PO Template",
      path: "/quotes",
      icon: quotesIcon,
      page: "quotingTool",
    },
  ];

  const allowedCards = dashboardCards.filter((card) =>
    hasAccess(accessMap, card.page, "V")
  );

  return (
    <div className="dashboard-container">
      <div className="dashboard-header">
        <Title level={3} style={{ color: "#FFFFFF" }}>
          Hello, {userName}
        </Title>
        <Text style={{ color: "#FFFFFF" }}>
          Logged in as {userEmail}
        </Text>
      </div>

      <div className="dashboard-grid">
        {allowedCards.map((card, index) => (
          <div
            key={index}
            className={`dashboard-card
              ${card.title === "Customer Price Management" ? "long-title-card" : ""}
              ${card.title === "Product Management" ? "product-card" : ""}
            `}
            onClick={() => navigate(card.path)}
          >
            <div className="card-content">
              <div className="card-icon">
                <img
                  src={card.icon}
                  alt={card.title}
                  className="dashboard-icon-img"
                />
              </div>

              <div className="card-bottom-row">
                <div className="card-title">{card.title}</div>
                <div
                  className="view-link"
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate(card.path);
                  }}
                >
                  <img src={arrowIcon} alt="Go" className="arrow-icon" />
                </div>
              </div>
            </div>
          </div>
        ))}

        {allowedCards.length === 0 && (
          <Text type="secondary" style={{ marginTop: 20,color: "#FFFFFF" }}>
            You don't have access to any sections.
          </Text>
        )}
      </div>
    </div>
  );
};

export default Dashboard;
